// src/app/providers/AppProviders.js
import React, { useMemo } from "react";
import { ThemeProvider as MuiThemeProvider, CssBaseline } from "@mui/material";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { makeAppTheme } from "../../theme/theme";
import { styledTheme } from "../../theme/styledTheme";

export default function AppProviders({ children }) {
  const muiTheme = useMemo(() => makeAppTheme(), []);

  return (
    <MuiThemeProvider theme={muiTheme}>
      <StyledThemeProvider theme={styledTheme}>
        <CssBaseline />
        {children}
      </StyledThemeProvider>
    </MuiThemeProvider>
  );
}
